import { inject } from '@angular/core';
import { CanMatchFn, UrlSegment } from '@angular/router';
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';

import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

type SlugCheckResultDto = { exists: boolean; isActive: boolean };

// VALIDA EL SLUG EN EL SERVIDOR (asíncrono)
export const slugCanMatch: CanMatchFn = (_route, segments: UrlSegment[]) => {
  // Seguridad básica: esperamos exactamente 1 segmento
  if (segments.length !== 1) return false;

  // Tomar el primer segmento desde la URL real del browser (y fallback a segments[0])
  const firstSegment =
    (typeof window !== 'undefined'
      ? window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase()
      : (segments[0]?.path ?? '').trim().toLowerCase()) ?? '';

  const slug = (segments[0]?.path ?? '').trim().toLowerCase();
  if (!firstSegment) return false;

  // BYPASS de interceptores ABP (evita Authorization, etc.)
  const handler = inject(HttpBackend);
  const http = new HttpClient(handler);

  const base = environment.apis?.default?.url ?? '';
  const params = new HttpParams().set('slug', firstSegment);

  return http.post<SlugCheckResultDto>(`${base}/api/app/catalog/check-slug`, null, {
    params,
    withCredentials: false
  }).pipe(
    map(res => !!res && res.isActive === true), // true => la ruta matchea
    catchError(() => of(false))                 // error => no matchea
  );
};

